<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn color="primary" x-small text @click="() => $router.push({ name: 'home' })">
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Planos Bimestrais
        </h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-form>
          <v-card>
            <div class="text-start py-2 px-4 text-button">Pesquisa avançada</div>

            <v-divider class="theme--light"></v-divider>
            <v-row class="px-4 mt-4">
              <v-col v-if="permitirRolesParaGestores() >= 0">
                <v-text-field
                  v-model="professor"
                  label="NOME ou CPF Professor"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row class="d-flex justify-space-between mb-6 px-4">
              <v-col cols="12" sm="6" md="4">
                <v-autocomplete
                  :items="disciplinas"
                  :return-object="false"
                  v-model="disciplina"
                  label="Escolha uma disciplina"
                  item-text="descricao"
                  item-value="descricao"
                  outlined
                  dense
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-autocomplete
                  :items="turmas"
                  :return-object="false"
                  v-model="turma"
                  label="Escolha uma turma"
                  item-text="descricao"
                  item-value="descricao"
                  outlined
                  dense
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="6" md="4" s>
                <v-autocomplete
                  :items="bimestres"
                  :return-object="false"
                  v-model="bimestre"
                  label="Escolha um bimestre"
                  item-text="descricao"
                  item-value="id"
                  outlined
                  dense
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="12" md="12" class="mb-5">
                <v-btn color="primary" block @click="() => limparCampos()">Limpar filtros</v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-form>
      </v-col>

      <v-col>
        <v-data-table
          :loading="carregando"
          :headers="table.headers"
          :items="planos"
          :items-per-page="15"
          hide-default-footer
          class="elevation-1"
        >
          <template v-slot:body="{ items }">
            <tbody name="scroll-x-transition" is="transition-group" duration="150">
              <tr color="primary" v-for="plano of items" :key="plano.id">
                <td>{{ plano.id ? plano.id : "- - -" }}</td>
                <td>
                  {{ plano.gestao_de_aula.professor.nome }}
                </td>
                <td>{{ plano.gestao_de_aula.turma.descricao }}</td>

                <td>
                  <!-- {{ plano.status ? plano.status : "----" }} -->
                  <e-situacao-plano
                    :plano="plano"
                    @update="(e) => [carregarDadosAoAtualizarStatus(e)]"
                  />
                </td>

                <td>
                  {{ plano.bimestre ? plano.bimestre.descricao : "1º Bimestre" }}
                </td>

                <td>{{ plano.gestao_de_aula?.disciplina?.descricao }}</td>
                <td>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="abrirPlanoEmNovaAba(plano.id)"
                        x-small
                        class="ml-1"
                        v-bind="attrs"
                        color="primary"
                        v-on="on"
                      >
                        <v-icon small>mdi-note-text-outline </v-icon>
                      </v-btn>
                    </template>
                    <span>Visualizar</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="() => [visualizarPdf(plano.id), (dialog = true)]"
                        x-small
                        class="ml-1"
                        v-bind="attrs"
                        color="primary"
                        v-on="on"
                      >
                        <v-icon small>mdi-note </v-icon>
                      </v-btn>
                    </template>
                    <span>Visualizar Pdf</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="plano.path || plano.data_envio_pdf">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="() => [visualizarPdfAnexado(plano.id), (dialogPDF = true)]"
                        x-small
                        class="ml-1"
                        v-bind="attrs"
                        color="red"
                        v-on="on"
                      >
                        <v-icon small color="white">mdi-file-pdf-box</v-icon>
                      </v-btn>
                    </template>
                    <span>Plano anexado</span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>

        <e-paginate
          :current_page="paginate.current_page"
          :last_page="paginate.last_page"
          :pageNumber="pageNumber"
          @changeActionResponse="carregarPlanos"
          :search="search"
        >
        </e-paginate>
      </v-col>
    </v-row>

    <ModalCarteira :dialog="dialog" :pdf="pdf" v-on:update="carregarDadosAoAtualizarStatus" />
    <ModalPDF
      :dialogPDF="dialogPDF"
      :pdfAnexado="pdfAnexado"
      @update:dialogPDF="dialogPDF = $event"
    />
  </main-template>
</template>

<script>
import { dataTableFilter } from "@/plugins/searchQuery";
import ModalCarteira from "@/components/Matriculas/EModalPlanoBimestral.vue";
import ModalPDF from "@/components/Matriculas/EModalPlanoBimestralPDF.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    ModalCarteira,
    ModalPDF,
  },
  watch: {
    async professor(value) {
      value = this.formatarCPf(value);
      this.professor = value;
      await this.carregarPlanos();
    },
    async turma(value) {
      this.turma = value;
      await this.carregarPlanos();
    },
    async disciplina(value) {
      this.disciplina = value;
      await this.carregarPlanos();
    },
    async mes(value) {
      this.mes = value;
      await this.carregarPlanos();
    },
    async bimestre(value) {
      this.bimestre = value;
      await this.carregarPlanos();
    },
  },
  data() {
    return {
      carregando: false,
      dialog: false,
      pdf: null,
      disciplinas: [],
      bimestres: [],
      turmas: [],
      planos: [],
      descricaoDosBimestres: {
        1: "2° Bimestre",
        2: "3° Bimestre",
        3: "4° Bimestre",
      },
      professor: "",
      turma: "",
      disciplina: "",
      bimestre: "",
      dataTableFilter,
      search: "",
      pageNumber: 1,
      paginate: {
        current_page: 1,
        last_page: 0,
      },
      table: {
        headers: [
          { text: "#", value: "id" },
          { text: "Professor", value: "gestao_de_aula.professor.nome" },
          { text: "Turma", value: "gestao_de_aula.turma.descricao" },
          { text: "Status", value: "status" },
          { text: "Bimestre", value: "bimestre" },
          { text: "Disciplina", value: "gestao_de_aula.disciplina.descricao" },
          { text: "Ações", value: "actions", sortable: false },
        ],
      },
      dialogPDF: false,
      pdfAnexado: null,
    };
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
  },
  async mounted() {
    await this.carregarDados();
    this.permitirRolesParaGestores();
  },
  methods: {
    async carregarDados() {
      await this.carregarPlanos(this.pageNumber);
      await this.listarDisciplinas();
      await this.listarTurmas();
      await this.listarDisciplinas();
      await this.listarBimestres();
    },
    permitirRolesParaGestores() {
      try {
        // const userLocal = this.user?.role ? this.user.role.name : [];
        // return this.$constants.rolesParaGestores.findIndex((elem) => {
        //   return elem.name === userLocal;
        // });

        const userLocal = this.user.roles ? this.user.roleName : [];

        return this.$constants.rolesParaGestores.findIndex((elem) => {
          return elem.name === userLocal;
        });
      } catch (error) {
        this.$handleError(error);
      }
      return false;
    },
    async listarDisciplinas() {
      try {
        const { data } = await this.$services.planosBimestraisService.disciplinas();
        this.disciplinas = data;
      } catch (error) {
        this.$handleError(error);
      }
    },
    async listarTurmas() {
      try {
        const { data } = await this.$services.planosBimestraisService.turmas();
        const result = data.map((t) => {
          const local = { ...t };
          return (local.descricao = `${t.descricao} (${t.franquia.descricao})`);
        });
        this.turmas = result;
      } catch (error) {
        this.$handleError(error);
      }
    },
    async listarBimestres() {
      try {
        const { data } = await this.$services.planosBimestraisService.bimestres();
        this.bimestres = data;
      } catch (error) {
        this.$handleError(error);
      }
    },
    async carregarPlanos(numeroDaPagina = null) {
      try {
        this.dialog = false;
        this.carregando = true;
        const pagina = numeroDaPagina || this.pageNumber;
        const payload = await this.$services.planosBimestraisService.index(
          pagina,
          this.professor,
          this.turma,
          this.disciplina,
          this.bimestre
        );
        this.planos = payload.data;
        this.paginate = payload;
        this.carregando = false;
      } catch (error) {
        this.$handleError(error);
      }
    },
    async carregarDadosAoAtualizarStatus() {
      try {
        await this.carregarPlanos(this.paginate.current_page);
      } catch (error) {
        this.$handleError(error);
      }
    },
    limparCampos() {
      this.professor = "";
      this.turma = "";
      this.disciplina = "";
      this.mes = "";
      this.bimestre = "";
    },
    formatarCPf(value) {
      value = value.replace("-", "");
      value = value.replace(".", "");
      return value;
    },
    async visualizarPdf(planoId) {
      this.pdf = await this.$services.planosBimestraisService.pdf(planoId);
    },
    async visualizarPdfAnexado(planoId) {
      try {
        this.pdfAnexado = await this.$services.planosBimestraisService.pdfAnexado(planoId);
      } catch (error) {
        this.$handleError(error);
      }
    },
    abrirPlanoEmNovaAba(planoId) {
      const url = this.$router.resolve({
        name: "gestoesDeAulas.planosVisualizar",
        params: { id: planoId },
      }).href;
      window.open(url, "_blank");
    },
  },
};
</script>
<style></style>
